/** calendar-days — outer 20×20, leaf inset 8.33% / 12.5%, stroke overflow -4.5% / -5% */
export const CalendarDaysIcon = () => (
    <span className="relative inline-block size-5 shrink-0 overflow-hidden" aria-hidden>
        <span className="absolute inset-[8.33%_12.5%]">
            <span className="absolute inset-[-4.5%_-5%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 16.5 18.1667"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M4.91667 0.75V4.08333M11.5833 0.75V4.08333M0.75 7.41667H15.75M4.91667 10.75H4.925M8.25 10.75H8.25833M11.5833 10.75H11.5917M4.91667 14.0833H4.925M8.25 14.0833H8.25833M11.5833 14.0833H11.5917M2.41667 2.41667H14.0833C15.0038 2.41667 15.75 3.16286 15.75 4.08333V15.75C15.75 16.6705 15.0038 17.4167 14.0833 17.4167H2.41667C1.49619 17.4167 0.75 16.6705 0.75 15.75V4.08333C0.75 3.16286 1.49619 2.41667 2.41667 2.41667Z"
                        stroke="#767676"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

/** book-open-text — outer 20×20, leaf inset 12.5% / 8.33%, stroke overflow -5% / -4.5% */
export const BookOpenTextIcon = () => (
    <span className="relative inline-block size-5 shrink-0 overflow-hidden" aria-hidden>
        <span className="absolute inset-[12.5%_8.33%]">
            <span className="absolute inset-[-5%_-4.5%]">
                <svg
                    className="block size-full"
                    viewBox="0 0 18.1667 16.5"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.08333 4.08333C9.08333 3.19928 8.73214 2.35143 8.10702 1.72631C7.4819 1.10119 6.63405 0.75 5.75 0.75H0.75V13.25H6.58333C7.24637 13.25 7.88226 13.5134 8.3511 13.9822C8.81994 14.4511 9.08333 15.087 9.08333 15.75M9.08333 4.08333V15.75M9.08333 4.08333C9.08333 3.19928 9.43452 2.35143 10.0596 1.72631C10.6848 1.10119 11.5326 0.75 12.4167 0.75H17.4167V13.25H11.5833C10.9203 13.25 10.2844 13.5134 9.81557 13.9822C9.34672 14.4511 9.08333 15.087 9.08333 15.75M4.08333 4.91667H5.75M4.08333 8.25H5.75M12.4167 4.91667H14.0833M12.4167 8.25H14.0833"
                        stroke="#767676"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </span>
        </span>
    </span>
);

/** arrow-up-right — 24×24 */
export const ArrowUpRightIcon = () => (
    <svg
        className="size-6 shrink-0"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <path
            d="M7 17L17 7M17 17V7H7"
            stroke="#101828"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/** Ellipse 1495 — 5×5 */
export const MetaDot = () => (
    <svg
        className="size-[5px] shrink-0"
        viewBox="0 0 5 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
    >
        <circle cx="2.5" cy="2.5" r="2.5" fill="#767676" />
    </svg>
);
